import { StatusAprovacao } from '@acme/core'
import { Chip, Typography } from '@mui/material'
import { GridCellParams } from '@/global/components/DataGrid/utils/types'

export function Status(params: GridCellParams) {
    let { statusAprovacao } = params.row
    if (statusAprovacao === undefined)
        statusAprovacao = StatusAprovacao.APROVADO

    let label = String(statusAprovacao)
    if (statusAprovacao === StatusAprovacao.PENDENTE_EXCLUSAO) {
        label = 'exclusão pendente'
    }

    return (
        <Chip
            label={
                <Typography
                    color="ButtonText"
                    variant="body2"
                    textTransform="uppercase"
                >
                    {label}
                </Typography>
            }
            color={
                statusAprovacao === StatusAprovacao.APROVADO
                    ? 'success'
                    : statusAprovacao === StatusAprovacao.REPROVADO
                      ? 'error'
                      : 'warning'
            }
        />
    )
}
